import {GeometryModifier} from "./types";
import {ExtrudeGeometry} from "three";
import {GeneratorValues} from "../../product-types";
import * as THREE from "three";

export const Twist: GeometryModifier = {
    apply(geometry: ExtrudeGeometry, values: GeneratorValues): ExtrudeGeometry {
        if(values.twistAmount === 0 || !values.twistAmount) {
            return geometry;
        }

        const twist = values.twistAmount as number

        const quaternion = new THREE.Quaternion()
        const positions = geometry.attributes.position

        for (let i = 0; i < positions.count; i++) {
            // Calculate the twist factor based on the y position of the vertex
            const vertex = new THREE.Vector3()
            vertex.fromBufferAttribute(positions, i)
            const twistFactor = (vertex.z / values.height) * twist

            // Apply the twist
            quaternion.setFromAxisAngle(new THREE.Vector3(0, 0, 1), twistFactor)
            vertex.applyQuaternion(quaternion)

            // Apply side function
            const scalar = 0;

            const distance = new THREE.Vector2(vertex.x, vertex.y)
            const newDistance = distance.multiplyScalar(1 + scalar / distance.length())

            positions.setXYZ(i, newDistance.x, newDistance.y, vertex.z)
        }

        return geometry;
    }
}